import type { FeatureRoute } from '../types';
import { DeliveryDetailPage } from './deliveries/DeliveryDetailPage';
import { InvoiceDetailPage } from './invoices/InvoiceDetailPage';
import { InvoiceNewPage } from './invoices/InvoiceNewPage';
import { InvoicesPage } from './invoices/InvoicesPage';
import { OrderDetailPage } from './orders/OrderDetailPage';
import { OrderEditPage, OrderNewPage } from './orders/OrderEditorPage';
import { OrdersPage } from './orders/OrdersPage';
import { CounterSalePage } from './counter/CounterSalePage';

/** Routes owned by this feature (paths are relative to the app root, e.g. 'customers/:id'). */
export const routes: FeatureRoute[] = [
  // Fast sale (counter). `pos/*` is reserved for the separate POS module (W10). The sidebar's
  // "New sale" item links to /sell, so that path stays as an alias of sales/counter.
  { path: 'sales/counter', element: <CounterSalePage /> },
  { path: 'sell', element: <CounterSalePage /> },
  { path: 'sales/invoices', element: <InvoicesPage /> },
  { path: 'sales/invoices/new', element: <InvoiceNewPage /> },
  { path: 'sales/invoices/:id', element: <InvoiceDetailPage /> },
  { path: 'sales/orders', element: <OrdersPage /> },
  { path: 'sales/orders/new', element: <OrderNewPage /> },
  { path: 'sales/orders/:id', element: <OrderDetailPage /> },
  { path: 'sales/orders/:id/edit', element: <OrderEditPage /> },
  { path: 'sales/deliveries', element: <OrdersPage /> },
  { path: 'sales/deliveries/:id', element: <DeliveryDetailPage /> },
];
